import React, { useState, useContext, useEffect, useRef } from "react";
import Col from "../../UIcomponent/Column";
import { HeaderPlatFormItemList, HeaderUserItemList } from "./HeaderItemList";
import Logo from "../../UIcomponent/Icon/Logo";
import PersianLogoType from "../../UIcomponent/Icon/PersianLogoType";
import "./Header.scss";
import { ThemeContext } from "styled-components";
import LocalContext from "../../Context/LocalContetxt";
import StyledLink from "../../UIcomponent/Link";
import StyledButton from "../../UIcomponent/Button";
import { PublicDic } from "../../Utility/PublicDic";
import Modal from "../../UIcomponent/Modal";
import LoginRegister from "../LoginRegister/LoginRegister";
import HeaderReq from "../../Utility/Requester/HeaderReq";
import LocalConfig from "../../Utility/Method/LocalConfig";
import AvatarDefault from "../../Assets/images/AvatarDefault.jpg";
import Urls from "../../Utility/Urls";
import { useLocation } from "react-router-dom";
import NotificationManager, {
  Notify,
} from "../../UIcomponent/NotificationManager";
import TeacherRegister from "../TeacherRegister/TeacherRegister";
import LocalAppConfig from "../../Utility/Method/LocalAppConfig";
import StyledAvatar from "../../UIcomponent/StyledAvatar";
import HambergurMenu from "../../UIcomponent/Icon/HambergurMenu";
import HeaderLink from "./HeaderLink";
import SideMenu from "../SideMenu/SideMenu";
// import DefaultAvatar from "../../UIcomponent/DefaultAvatar";

import {
  styled,
  Typography,
  Chip,
  Collapse,
  IconButton,
  InputBase,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseRounded";
window.notificationOpen = false;
// import { Link } from "react-router-dom"
const HeaderActionButton = styled(StyledButton)`
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  font-family: "Fa_IRANSansBold";
  font-weight: 800;
  :hover {
    background-color: ${(props) => props.hoverBackgroundColor};
    color: ${(props) => props.hoverColor};
  }
`;
const Header = (props) => {
  const [state, setstate] = useState({
    avatar: "",
    showLoginRegister: false,
    showTeacherRegister: false,
    mode: "login",
  });
  const TeacherRoute = "/jointeacher";
  const [pathname, setPathname] = useState("");
  const [sideMenuVisible, setSideMenuVisible] = useState(false);
  const location = useLocation();
  const SideRef = useRef();
  const AvatarRef = useRef();
  const voucherRef = useRef();
  const [notificationOpen, setNotificationOpen] = React.useState(false);
  const theme = useContext(ThemeContext);
  const localctxt = useContext(LocalContext);
  const lang = localctxt.lang;
  const hasToken = localctxt.hasToken;
  const setConfigs = localctxt.setConfig;
  let config = localctxt.config;
  let localAppConfig = LocalAppConfig.Get();
  let width = window.innerWidth;

  useEffect(() => {
    const header = document.getElementById("lingo_header");
    const sticky = header.offsetTop;
    const scrollCallBack = window.addEventListener("scroll", () => {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });
    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
  }, []);

  const collapseNotification = (_) => {
    // Create the event
    var event = new CustomEvent("notificationCollapsed");

    document.dispatchEvent(event);
    setNotificationOpen(false);
    window.notificationOpen = true;
  };

  const mouseMove = (e) => {
    if (AvatarRef && AvatarRef.current) {
      if (
        AvatarRef.current.contains(e.target) ||
        SideRef.current.contains(e.target)
      ) {
        setSideMenuVisible(true);
        document.body.style.overflowY = "hidden";
      } else {
        setSideMenuVisible(false);
        document.body.style.overflowY = "auto";
      }
    }
  };

  useEffect(() => {
    if (hasToken === true) {
      HeaderReq.Config()
        .then((res) => {
          if (
            !JSON.stringify(config) ||
            !config ||
            JSON.stringify(res.data) !== JSON.stringify(config)
          ) {
            LocalConfig.Set(res.data);
            setConfigs(res.data);
            // setRole(res.data.role);
          }
        })
        .catch((err) => {});
    }
    if (
      !localAppConfig.time ||
      Date.now() - Number(localAppConfig.time) > 24 * 60 * 60 * 1000
    ) {
      HeaderReq.AppConfig()
        .then((res) => {
          LocalAppConfig.Set({
            ...res.data,
            time: Date.now(),
          });
        })
        .catch((err) => {});
    }
    if (pathname !== location.pathname.toLowerCase()) {
      setPathname(location.pathname.toLowerCase());
    }
    window.addEventListener("mousemove", mouseMove);
    return () => {
      window.removeEventListener("mousemove", mouseMove);
    };
  }, [location, hasToken, localAppConfig.time, pathname, config, setConfigs]);
  const loginRegister = (mode) => {
    setstate({
      ...state,
      showLoginRegister: true,
      mode,
    });
  };
  const TeacherRegisterHandler = () => {
    setstate({
      ...state,
      showLoginRegister: false,
      showTeacherRegister: true,
    });
  };
  const cancelModal = () => {
    setstate({
      ...state,
      showLoginRegister: false,
    });
  };
  const menuItemClick = () => {
    setSideMenuVisible(false);
    document.body.style.overflowY = "auto";
  };

  const copyVoucher = (_) => {
    var textBox = voucherRef.current;
    textBox.select();
    document.execCommand("copy");
    Notify("success", "کد تخفیف کپی شد", 4000);
    textBox.blur();
  };
  return (
    <>
      <NotificationManager />

      <header
        id="lingo_header"
        className={`${
          pathname === "/" || pathname == TeacherRoute
            ? "l__Header--Landing"
            : "l__Header"
        }`}
        style={{
          boxShadow:
            pathname === "/" ||
            pathname === "/teachers" ||
            pathname === TeacherRoute
              ? "none"
              : "1px 1px 10px -5px #cdcdcd",
          borderBottom:
            pathname === "/teachers"
              ? `0.7px solid ${theme.lightGray}`
              : "none",
        }}
      >
        <Collapse in={notificationOpen}>
          <div className="notification-bar">
            <IconButton
              onClick={collapseNotification}
              color="inherit"
              className="closeIcon"
            >
              <CloseIcon />
            </IconButton>

            <img
              width="24"
              alt="🥳"
              className="emoji"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAvVBMVEVHcEzdLkTwemVSpePgNkv/zE3iP1S+r374x0v/zE1ltPH3pFDeMkf/zE3/zE1BisBmpndVrO6AtFToUmP/zE3/zE3hO1F3slU7iMOEtVTfNETqWW7qWW7dLkT/zE3xu0DmSV+KZRHYwm70k1R2uOnosTiIyfnjpy21iyhVrO5zUQh4slWedhxbodblUkaapoP6rlEiZpmpgCI0d6q/oDxHdIo7iMO9yqtmRQD8u09VZFbscUjUpjdll6qiytRhX1O5AAAAHHRSTlMAv/1X/lZHEPzRwiaBj7/2N997n4CvvLy/5c+vWOphrQAAA8JJREFUeF6d2Od2qzoQBWBsU4NLYvvklCs6rr2kt/d/rKuGRligQPbfrPWtPSMUGxv2fafT6fdt2zHapHe3Wt31DCn3KOAxO5O+7Td0VjS9EhQHpfy7b8DdMeiuBCEzUIPb6YZd8UhQByEU1MT8954dQxJvOLWwa0/0UBzokoU83mCCJrWjdWIsaaH3UKSLsKQsGyB9pVeAEM7EUY4fINSs0BGRdC2jKh0TaSvtQ0iGmDT0ayFk1jjmUYK6lMEH6VoVUIB0lbJQCkVYBnUQMrWOml8OB27/3nIohkqaRSvxuDTebMYOQFBJcTQShzakVL+A4qYOTEeh3xuSMYZMBJUUR5sBQL8lKG7qQCwMbWgcDAUIKrVzQtc3HOrQHQUxVFIdfYbGLdsQQFAJnAaxxnRBODZAUCkLm8YbE4dDJoJK4DTMX7xoFYrhnjYNXTSHAiRX2rdyQrxogGKp0v41bJUHz+ApQeg9bB2/CjqG7TMQEGxbP5b7sdwmyXn5UYb4bE4gtt3VMtH2RWRbstjxW/sCyrRtGANU6eqSTPdsSV3tWLM1AyBSpymFhgQycR1tuLPeLpcJMx/km0vi7avu6McywdkuIw6xcWa8Hh4zca+3HWb77Goq97y+nuCM20jDROWDY5CSpbyPZVHxASpAdJCbgAIQRA/JDqwV7+kc/hRiTgI7+CF01szTClqzR0QTt7z09HBIq6DkOydaLCJgDqMnnFGPQF4JmiVr7VyzxWIxE+U+n3j+OPiKKOX1faAROFjCl1YF9IWKHaXYgfQMq4XjSn1Ssh65ktNyssLJ5/N5vgOJbvt4vB5g5kr7x3d9Jv7AnTlLLkGDMMy61wPA2UT0Cq8jConJvrCR54TaCcgPQ4Rer1cqhti+vD0+Pr4dUleCUuycTqdLLjqNyJN0vP6/H0XQaS3Kjz4PhwdW9Hk+fzqR5EWlPxiyuggh9aDZGO6bgIBLBXTBw9FCjoFT+RHCh4sEBJmT7E40OwbRS2IjEuWoeSUV2s1pLgwis43YF5JJ9Yc1h7aPNVAuIO446ses/NBEa3xqCkSlC9sRdwy75nM/whA8kG6aHg6fnwKC3DgGy38cyqogiMt4Aj5/fSkOTNbVQqqYps/PXzc38Dbq923bJxelckf6DIyK/Ko+Nf1LTVUcT22khzzHaCS5s5YOSMp02rlUx7lZrcghKhtvu2fsYImaltuMca36n3BYU3/YxBn6Rj1UsJb3HePROprReJypdj53CluuXTa00rRpF39QYXkD3/hBHGs6pBr8NKbL/2aIFbIj35tyAAAAAElFTkSuQmCC"
            ></img>
            <Typography className="inherit-font">
              سلام! اگه اولین بار از ما خرید می کنید از کد
              <Chip onClick={copyVoucher} label="Lingotalk" className="chip" />
              استفاده کن و ۲۰ هزار تومان تخفیف بگیر!
            </Typography>
            <InputBase
              style={{ position: "fixed", top: -99999999999, opacity: 0 }}
              inputRef={voucherRef}
              value="Lingotalk"
            />
          </div>
        </Collapse>
        <div className="top-header">
          <Col
            xl={pathname !== "/" && pathname !== TeacherRoute ? 11.5 : 11}
            lg={14}
            md={14}
            sm={11}
            xs={11}
            className="c__Header__Logo"
          >
            <Col className="o__Header__Logo__img">
              <StyledLink force to="/">
                <Logo fill="#5340e7" />
                <PersianLogoType
                  width="130"
                  height="70"
                  className="o__Header__Logo__img--LogoType"
                  fill={"#5340e7"}
                />
              </StyledLink>
            </Col>

            {pathname !== TeacherRoute && (
              <Col
                xl={17.5}
                lg={18}
                md={18}
                sm={18}
                xs={12}
                className={`o__Header__Logo__item ${
                  pathname === "/" ? "white" : ""
                }`}
              >
                <HeaderLink items={HeaderPlatFormItemList} />
              </Col>
            )}
          </Col>
          <Col
            xl={pathname !== "/" || pathname === TeacherRoute ? 11.5 : 11}
            lg={8}
            md={8}
            sm={11}
            xs={11}
            className="c__Header__Options"
          >
            {hasToken == true ? (
              pathname.toLocaleLowerCase() !== "/jointeacher" && (
                <>
                  <Col className="o__Header__Options__Links">
                    <HeaderLink
                      items={HeaderUserItemList}
                      role={config && config.role}
                    />
                  </Col>
                  <Col
                    className="c__Header__Avatar"
                    innerRef={AvatarRef}
                    style={{
                      display: pathname === TeacherRoute && "none",
                    }}
                  >
                    {
                      <StyledAvatar
                        className="o__Header__Avatar"
                        borderSize={1.5}
                        onClick={mouseMove}
                        source={
                          config && config.avatar && config.avatar !== ""
                            ? Urls.avatar() + config.avatar
                            : AvatarDefault
                        }
                      />
                    }
                  </Col>
                </>
              )
            ) : (
              <>
                <Col
                  className="c__Header__Options__HambergurMenu"
                  innerRef={AvatarRef}
                  style={{
                    display: width < 768 ? "flex" : "none",
                  }}
                >
                  <HambergurMenu
                    fill={
                      pathname === "/" || pathname === TeacherRoute
                        ? "white"
                        : theme.primary
                    }
                  />
                </Col>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={0}
                  xs={0}
                  style={{
                    display: width < 768 ? "none" : "flex",
                  }}
                  className="c__Header__Options__Buttons"
                >
                  <HeaderActionButton
                    // primary
                    backgroundColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? "transparent"
                        : "transparent"
                    }
                    color={
                      pathname === "/" || pathname === TeacherRoute
                        ? "white"
                        : theme.textBold
                    }
                    hoverBackgroundColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? "white"
                        : "rgb(250, 246, 244)"
                    }
                    hoverColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? theme.primary
                        : theme.textBold
                    }
                    style={{
                      width: "80px",
                      margin: "0px 0px 0px 10px",
                      border:
                        pathname === "/" || pathname === TeacherRoute
                          ? "1px solid white"
                          : `none`,
                      borderRadius:
                        (pathname === "/" || pathname === TeacherRoute) &&
                        "25px",
                      "&.hover": {
                        border:
                          (pathname === "/" || pathname === TeacherRoute) &&
                          "none",
                      },
                    }}
                    onClick={() => loginRegister("login")}
                  >
                    {PublicDic.login[`${lang}`]}
                  </HeaderActionButton>

                  <HeaderActionButton
                    // default
                    backgroundColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? "transparent"
                        : "white"
                    }
                    color={
                      pathname === "/" || pathname === TeacherRoute
                        ? "white"
                        : theme.textBold
                    }
                    hoverBackgroundColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? "white"
                        : "rgb(250, 246, 244)"
                    }
                    hoverColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? theme.primary
                        : theme.textBold
                    }
                    style={{
                      width: "80px",
                      margin: "0px 0px 0px 10px",
                      border:
                        pathname === "/" || pathname === TeacherRoute
                          ? "1px solid white"
                          : `none`,
                      borderRadius:
                        (pathname === "/" || pathname === TeacherRoute) &&
                        "25px",
                      "&:hover": {
                        border:
                          (pathname === "/" || pathname === TeacherRoute) &&
                          "none",
                      },
                    }}
                    onClick={() => loginRegister("register")}
                  >
                    ثبت نام
                  </HeaderActionButton>
                  <HeaderActionButton
                    onClick={TeacherRegisterHandler}
                    // default
                    // notHoverable
                    backgroundColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? "transparent"
                        : "white"
                    }
                    color={
                      pathname === "/" || pathname === TeacherRoute
                        ? "white"
                        : theme.textBold
                    }
                    hoverBackgroundColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? "white"
                        : "rgb(250, 246, 244)"
                    }
                    hoverColor={
                      pathname === "/" || pathname === TeacherRoute
                        ? theme.primary
                        : theme.textBold
                    }
                    style={{
                      width: "120px",
                      margin: "0px 0px 0px 10px",
                      border:
                        pathname === "/" || pathname === TeacherRoute
                          ? "1px solid white"
                          : `none`,
                      borderRadius:
                        (pathname === "/" || pathname === TeacherRoute) &&
                        "25px",
                      "&:hover": {
                        border:
                          (pathname === "/" || pathname === TeacherRoute) &&
                          "none",
                      },
                    }}
                  >
                    ثبت نام استاد
                  </HeaderActionButton>
                </Col>
              </>
            )}
          </Col>
          {hasToken === false && state.showLoginRegister && (
            <Modal visible={state.showLoginRegister} onCancel={cancelModal}>
              <LoginRegister mode={state.mode} key={state.mode} />
            </Modal>
          )}
          {hasToken === false && state.showTeacherRegister && (
            <Modal
              visible={state.showTeacherRegister}
              onCancel={() => {
                setstate({
                  ...state,
                  showTeacherRegister: false,
                });
              }}
            >
              <TeacherRegister />
            </Modal>
          )}
        </div>
      </header>

      <SideMenu
        visible={sideMenuVisible}
        ref={SideRef}
        pathname={pathname}
        teacherRoute={TeacherRoute}
        isLoggedin={hasToken}
        lang={lang}
        loginRegisterHanlder={loginRegister}
        teacherRegisterHandler={TeacherRegisterHandler}
        role={config ? config.role : null}
        onClick={menuItemClick}
      />
    </>
  );
};

export default Header;
